var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSardines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0C15E;}\n\t.st1{fill:#1C8079;}\n\t.st2{fill:#325CA7;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M103.86,184.22c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C26.57,149.93,61.17,184.22,103.86,184.22"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.47,62.84c0.96,1.45,1.07,3.36,2.15,4.73c0.99,1.26,2.6,1.83,3.83,2.85c0.2,0.17,0.41,0.39,0.4,0.65 c-0.01,0.23-0.18,0.43-0.34,0.59c-1.77,1.81-3.87,3.39-6.31,4.09c-2.95,0.85-8.74,0.12-8.07-4.08 C89.7,68.13,94.73,64.65,97.47,62.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.1,91.67c0.65-2,1.1-4.54,0.6-6.59c-3.23-0.33-7.93-0.89-6.87,3.56C94.51,91.44,98.45,96.81,100.1,91.67z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.46,83.09c0.79-0.63,1.89-0.66,2.89-0.56c6.87,0.73,17.08,7.96,18.75,5.88c2.26-2.81-3.06-5.15-5.45-7.84 c1.92-2.09,3.83-4.18,5.75-6.27c0.78-0.86,1.55-2.27,0.67-3.02c-0.46-0.39-1.16-0.33-1.75-0.18c-2.36,0.6-4.33,2.2-6.54,3.23 c-5.04,2.34-11.17,1.67-15.97,4.47c-1,0.58-2.01,1.81-1.35,2.75c0.32,0.45,0.91,0.61,1.46,0.71c1.93,0.34,3.92,0.32,5.84-0.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.76,87.24c5.37,1.28,10.95,1.32,16.48,1.24c17.36-0.25,35.01-1.61,51.21-7.85 c-1.53,0.59-7.82-2.67-9.53-3.21c-3.53-1.12-7.09-2.15-10.67-3.06c-6.95-1.76-14.04-3.07-21.2-3.56 c-13.92-0.94-32.12-2.13-39.37,8.02C59.12,83.62,63.07,85.88,68.76,87.24z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.47,121.44c0.96,1.45,1.07,3.36,2.15,4.73c0.99,1.26,2.6,1.83,3.83,2.85c0.2,0.17,0.41,0.39,0.4,0.65 c-0.01,0.23-0.18,0.43-0.34,0.59c-1.77,1.81-3.87,3.39-6.31,4.09c-2.95,0.85-8.74,0.12-8.07-4.08 C89.7,126.73,94.73,123.25,97.47,121.44z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.1,150.27c0.65-2,1.1-4.54,0.6-6.59c-3.23-0.33-7.93-0.89-6.87,3.56 C94.51,150.04,98.45,155.4,100.1,150.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M123.46,141.69c0.79-0.63,1.89-0.66,2.89-0.56c6.87,0.73,17.08,7.96,18.75,5.88 c2.26-2.81-3.06-5.15-5.45-7.84c1.92-2.09,3.83-4.18,5.75-6.27c0.78-0.86,1.55-2.27,0.67-3.02c-0.46-0.39-1.16-0.33-1.75-0.18 c-2.36,0.6-4.33,2.2-6.54,3.23c-5.04,2.34-11.17,1.67-15.97,4.47c-1,0.58-2.01,1.81-1.35,2.75c0.32,0.45,0.91,0.61,1.46,0.71 c1.93,0.34,3.92,0.32,5.84-0.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.76,145.83c5.37,1.28,10.95,1.32,16.48,1.24c17.36-0.25,35.01-1.61,51.21-7.85 c-1.53,0.59-7.82-2.67-9.53-3.21c-3.53-1.12-7.09-2.15-10.67-3.06c-6.95-1.76-14.04-3.07-21.2-3.56 c-13.92-0.94-32.12-2.13-39.37,8.02C59.12,142.22,63.07,144.48,68.76,145.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.26,90.39c-0.96,1.45-1.07,3.36-2.15,4.73c-0.99,1.26-2.6,1.83-3.83,2.85c-0.2,0.17-0.41,0.39-0.4,0.65 c0.01,0.23,0.18,0.43,0.34,0.59c1.77,1.81,3.87,3.39,6.31,4.09c2.95,0.85,8.74,0.12,8.07-4.08C124.02,95.68,119,92.2,116.26,90.39 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M113.63,119.21c-0.65-2-1.1-4.54-0.6-6.59c3.23-0.33,7.93-0.89,6.87,3.56 C119.22,118.99,115.27,124.35,113.63,119.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.27,110.63c-0.79-0.63-1.89-0.66-2.89-0.56c-6.87,0.73-17.08,7.96-18.75,5.88 c-2.26-2.81,3.06-5.15,5.45-7.84c-1.92-2.09-3.83-4.18-5.75-6.27c-0.78-0.86-1.55-2.27-0.67-3.02c0.46-0.39,1.16-0.33,1.75-0.18 c2.36,0.6,4.33,2.2,6.54,3.23c5.04,2.34,11.17,1.67,15.97,4.47c1,0.58,2.01,1.81,1.35,2.75c-0.32,0.45-0.91,0.61-1.46,0.71 c-1.93,0.34-3.92,0.32-5.84-0.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M144.97,114.78c-5.37,1.28-10.95,1.32-16.48,1.24c-17.36-0.25-35.01-1.61-51.21-7.85 c1.53,0.59,7.82-2.67,9.53-3.21c3.53-1.12,7.09-2.15,10.67-3.06c6.95-1.76,14.04-3.07,21.2-3.56c13.92-0.94,32.12-2.13,39.37,8.02 C154.61,111.17,150.66,113.42,144.97,114.78z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSardines);
export default __webpack_public_path__ + "static/media/Sardines.bc556ccc6553ebaf0760a520225726f0.svg";
export { ForwardRef as ReactComponent };